import { render, staticRenderFns } from "./outofstockRecords.vue?vue&type=template&id=0dee14a8&scoped=true&"
import script from "./outofstockRecords.vue?vue&type=script&lang=js&"
export * from "./outofstockRecords.vue?vue&type=script&lang=js&"
import style0 from "./outofstockRecords.vue?vue&type=style&index=0&id=0dee14a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee14a8",
  null
  
)

export default component.exports